<template>
    <v-sheet style="position: relative">
        <vertical-table class="body-info__table" v-bind="{ items, class: { blinded } }" />
        <v-fade-transition>
            <v-overlay v-show="blinded" absolute :dark="false" color="#F1F2F6" opacity="0.8" class="body-info__overlay" style="margin-top: 2px">
                <v-layout column align-center>
                    <p class="page-text--lg font-weight-medium primary--text">호스트 연락처 정보는 로그인 후 확인 가능합니다.</p>
                    <dialog-login>
                        <template #activator="{ attrs, on }">
                            <v-btn color="primary" class="mt-12 mt-lg-24" v-bind="attrs" v-on="on">
                                <span> 로그인 하러가기 </span>
                            </v-btn>
                        </template>
                    </dialog-login>
                </v-layout>
            </v-overlay>
        </v-fade-transition>
    </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import { initExpoProgram } from "@/assets/variables/inits";

import DialogLogin from "@/components/client/login/dialog-login.vue";
import VerticalTable from "@/components/dumb/vertical-table.vue";

export default {
    components: {
        DialogLogin,
        VerticalTable,
    },
    props: {
        program: { type: Object, default: initExpoProgram },
    },
    computed: {
        ...mapState({
            blinded: (store) => !store.payload,
        }),
        items() {
            return [
                { term: "담당자", data: this.program.host.workerName || "-" },
                { term: "이메일", data: this.program.host.email || "-" },
                { term: "연락처", data: this.program.host.phone || "-" },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
.body-info {
    &__table.blinded {
        &::v-deep .row {
            filter: blur(3px);
        }
    }
}
</style>